import { fromUnixTime } from "date-fns";
import { match } from "ts-pattern";

import { ForgeAction, MidgardAction } from "./types";

export const parseAction = (action: MidgardAction): ForgeAction => {
  const conditionalProps = match(action)
    .with(
      {
        type: "thorname",
      },
      (a) =>
        ({
          type: "thorname",
          to: a?.metadata?.thorname?.owner,
          thorname: a?.metadata?.thorname?.thorname,
        }) as const,
    )
    .with(
      {
        type: "send",
      },
      (a) =>
        ({
          type: "send",
          to: a?.out?.[0]?.address,
        }) as const,
    )
    .otherwise(() => {
      // report to sentry unsupported type
      return;
    });

  const amount = action?.in?.[0]?.coins?.[0]?.amount || "0";

  // @ts-expect-error FIX conditionalProps is not always defined
  return {
    ...conditionalProps,
    from: action?.in?.[0]?.address,
    txHash: action?.in?.[0]?.txID,
    amount,
    date: fromUnixTime(parseInt(action?.date) / 10e8),
    status: action?.status === "success" ? "success" : "unsupported",
  };
};
